import * as React from "react";
import { useDropHandler, UseDropHandlerOptions } from "./useDropHandler";

interface DropZoneProps extends UseDropHandlerOptions {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const DropZone: React.FC<DropZoneProps> = ({
  children,
  className = "",
  style,
  formId,
  fieldName,
  actionLabel,
  accept,
}) => {
  const { isDragOver, dropHandlers } = useDropHandler({
    formId,
    fieldName,
    actionLabel,
    accept,
  });

  return (
    <div
      {...dropHandlers}
      className={`relative rounded ${className}`}
      style={{
        ...style,
        outline: isDragOver ? "2px dashed var(--color-primary)" : "none",
        outlineOffset: -2,
      }}
    >
      {isDragOver && (
        <div
          className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none rounded"
          style={{ backgroundColor: "var(--color-primary-faint)" }}
        >
          <span style={{ color: "var(--color-primary)" }}>Drop file to import</span>
        </div>
      )}
      {children}
    </div>
  );
};
